export const INSERT_FILE_BUTTON = 'insert-file-button';
export const ROOT = 'file-upload-viewer';
export const FILE_UPLOAD_NAME_CONTAINER = 'file-upload-name-container';
export const FILE_UPLOAD_NAME = 'file-upload-name';
export const FILE_UPLOAD_EXTENSION = 'file-upload-extension';
